import { UPLOAD_DOCUMENT } from "../actions";

import { API } from "@aws-amplify/api";
import config from "../../../aws-exports.js";
import { getFromServer } from "../../global/middleware";

let originalFetch = require("isomorphic-fetch");
let fetch = require("fetch-retry")(originalFetch);

API.configure(config);
let uploadUrl;

export function fileMiddleware({ dispatch }) {
  return function (next) {
    return async function (action) {
      switch (action.type) {
        case UPLOAD_DOCUMENT:
          const selectedFile = action.data.selectedFile;
          const questObject = {
            resource: "getPresignedUrl",
            params: {
              path: action.data.path,
              user: action.data.user,
              content_type: selectedFile.type,
            },
          };

          const getUploadUrl = await getFromServer(questObject);

          if (getUploadUrl?.url) {
            uploadUrl = getUploadUrl?.url;
            const response = await fetch(uploadUrl, {
              method: "PUT",
              body: selectedFile,
              headers: { "Content-Type": selectedFile.type },
            });
            if (response.ok) {
              action.result = "File uploaded successfully!";
            } else {
              action.errors = `Upload failed: ${response.statusText} (${response.status})`;
            }
          } else {
            action.errors = `Configuration Error: Response Code ${getUploadUrl.responseCode}`;
            console.log(
              "action.errors",
              action.errors,
              "getResult",
              getUploadUrl,
            );
          }
          break;
      }
      return next(action);
    };
  };
}
